e4.util.stringify = function ( objValue ) {
    return typeof objValue === 'string' ? objValue : JSON.stringify( objValue );
}

e4.util.observer = {
    _instances: [],
    options: {
        root: null,
        rootMargin: '0px',
        threshold: 0
    },
    bind: function ( arrTargets, fnCallback, objOptions ) {
        e4.util.observer.observe( arrTargets, fnCallback, objOptions );
    },
    observe: function ( arrTargets, fnCallback, objOptions ) {
        var instance     = {};
        instance.id      = '_instance' + Math.random().toString( 36 ).substr( 2, 9 );
        instance.options = objOptions !== undefined ? objOptions : e4.util.observer.options;
        arrTargets.forEach( function ( target ) {
            instance.observer = new IntersectionObserver( function ( entries, observer ) {
                entries.forEach( function ( entry ) {
                    if ( typeof fnCallback === 'function' ) {
                        fnCallback( entry, observer );
                    }
                    else {
                        console.warn( 'No callback function defined' )
                    }
                } );
            }, instance.options );
            instance.observer.observe( target );
        } );
        e4.util.observer._instances.push( instance );
    }
};
